import Meta from '@/components/common/Meta'

import InternationalLuggageShippingPage from '@/v2/components/pages/landing-pages/international-luggage-shipping-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/international-luggage-shipping-page'

interface InternationalLuggageShippingPageProps {}

const Page: React.FC<InternationalLuggageShippingPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.international_luggage_shipping.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.international_luggage_shipping?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.international_luggage_shipping?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <InternationalLuggageShippingPage />
    </>
  )
}

export default Page
